import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

export const Pricing = ({handleSignUpRoute,handleContactUsRoute}) => {
  return (
    <Container className="py-3 text-center">
      {/* Header */}
      <div className="mb-4">
        <img
          src="./assets/DBlogo.png" // replace with actual logo path
          alt="Dollarbird Logo"
          style={{ height: "140px" }}
        />
        <h2 className="mt-3 fw-bold">Ads.txt Checker — Pricing</h2>
        <p className="text-muted">Choose the plan that fits your workflow. Upgrade anytime.</p>
      </div>

      <Row className="justify-content-center gap-0">
        {/* Free Trial */}
        <Col md={6} className="mb-4">
          <Card className="shadow-sm border-1 h-100">
            <Card.Body className="p-4 text-start position-relative">
                <div>
              <div className="bg-info text-white px-3 py-1 rounded-pill mb-1" style={{width:"fit-content",fontSize:"12px"}}>
                Free
              </div>
              </div>
              <h4 className="fw-bold">Free Trial</h4>
              <h2 className="fw-bold my-3">
                $0 <span className="fs-6 text-muted">/ 15 days</span>
              </h2>

              <ul className="list-unstyled mt-3 mb-4">
                <li className="mb-2">✔ <strong>15-day trial</strong> — full access during trial</li>
                <li className="mb-2">✔ <strong>50 domain scans</strong> total</li>
                <li className="mb-2">✔ Bulk paste & CSV export</li>
                <li className="mb-2">✔ Email verification & admin approval</li>
              </ul>

              <div className="d-grid">
                <Button variant="primary" size="lg" className="rounded-3" onClick={() => {handleSignUpRoute() }}>
                  Sign Up
                </Button>
              </div>
              <p className="text-muted mt-2 small">No credit card required</p>
            </Card.Body>
          </Card>
        </Col>

        {/* Unlimited Plan */}
        <Col md={6} className="mb-4">
          <Card className="shadow-sm h-100">
            <div
              className="position-absolute top-0 end-0 bg-primary text-white px-3 py-1"
              style={{ borderTopRightRadius: "5px", borderBottomLeftRadius: "8px" }}
            >
              Popular
            </div>
            <Card.Body className="p-4 text-start">
              {/* <span className="bg-success-subtle text-success px-3 py-2 rounded-pill mb-3">
                Paid
              </span> */}
              <div className="bg-success text-white px-3 py-1 rounded-pill mb-1" style={{width:"fit-content",fontSize:"12px"}}>
                Paid
              </div>
              <h4 className="fw-bold">Unlimited</h4>
              <h2 className="fw-bold my-3">
                $300 <span className="fs-6 text-muted">/ month</span>
              </h2>

              <ul className="list-unstyled mt-3 mb-4">
                <li className="mb-2">✔ <strong>Unlimited domain scans</strong></li>
                <li className="mb-2">✔ Priority processing & support</li>
                <li className="mb-2">✔ Multiple member team access</li>
                <li className="mb-2">✔ Renewal on 1st - irrespective of cancellation date</li>
              </ul>

              <div className="d-grid">
                <Button
                  variant="success"
                  size="lg"
                  className="rounded-3"
                  onClick={() => {handleContactUsRoute() }}
                >
                  Contact Us
                </Button>
              </div>
              <p className="text-muted mt-2 small">Enterprise options available</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Footer */}
      <p className="text-muted">
        Powered by <strong>Dollarbird Technologies Pvt Ltd</strong>
      </p>
    </Container>
  );
};

// export default Pricing;
